module.exports = __webpack_public_path__ + "assets/img/theX-prize-02.9ef9230d.png";